import directionStraightRight from '@iconify/icons-carbon/direction-straight-right';
// @mui
import { styled } from '@mui/material/styles';
import { Grid, Stack, Container, Typography, Button, Divider } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(8, 0),
  [theme.breakpoints.up('md')]: {
    paddingBottom: 0,
    paddingTop: theme.spacing(10),
  },
}));

// ----------------------------------------------------------------------

export default function AboutSection() {
  const { t } = useLocales();
  return (
    <RootStyle id="about">
      <Container>
        <Grid
          container
          rowSpacing={{ xs: 5, md: 0 }}
          columnSpacing={{ md: 3 }}
          justifyContent="space-between"
        >
          <Grid item xs={12} md={5} sx={{ textAlign: { xs: 'center', md: 'right' } }}>
            <Typography variant="overline" sx={{ color: 'text.disabled' }}>
              {t('aboutSection.overline')}
            </Typography>

            <Typography variant="h2" sx={{ mt: 2, mb: 3 }}>
              {t('aboutSection.heading')}
            </Typography>

            <Typography sx={{ color: 'text.secondary', fontSize: 12 }}>
              {t('aboutSection.description')}
            </Typography>

            <Button
              onClick={() =>
                window.open(
                  'https://www.linkedin.com/company/code-engine/about/?viewAsMember=true',
                  '_blank'
                )
              }
              size="large"
              endIcon={<Iconify icon={directionStraightRight} />}
              sx={{ mt: 5 }}
            >
              {t('aboutSection.learnMoreButton')}
            </Button>
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack spacing={5}>
              <LineItem
                total="28"
                label={t('aboutSection.projects.label')}
                text={t('aboutSection.projects.text')}
              />
              <LineItem
                total="16"
                label={t('aboutSection.happyClients.label')}
                text={t('aboutSection.happyClients.text')}
              />
              <LineItem
                total="10"
                label={t('aboutSection.yearsExperience.label')}
                text={t('aboutSection.yearsExperience.text')}
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}

// ----------------------------------------------------------------------

type LineItemProps = {
  total: string;
  label: string;
  text: string;
};

function LineItem({ total, label, text }: LineItemProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      divider={<Divider orientation="vertical" flexItem sx={{ ml: 3, mr: 5 }} />}
    >
      <Stack spacing={1} sx={{ width: 1, maxWidth: 100 }}>
        <Stack direction="row">
          <Typography variant="h2">{total}</Typography>
          <Typography variant="h4" sx={{ color: 'primary.main' }}>
            +
          </Typography>
        </Stack>
        <Typography variant="overline" sx={{ color: 'text.disabled' }}>
          {label}
        </Typography>
      </Stack>

      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {text}
      </Typography>
    </Stack>
  );
}
